import React from "react";
import { Stack } from "@mui/material";

import { useGetAllTreeData } from "../../hooks";
import { HubTableTemplate } from "../../components";

const sortable = true;
const items = [
  {
    id: "name",
    label: "Name",
    sortable,
  },
  {
    id: "weight",
    label: "Weight",
    sortable,
  },
];

const keys = [
  {
    value: "name",
  },
  {
    value: "weight",
  },
];

export const TreesTable = () => {
  const { data, isLoading } = useGetAllTreeData();

  const prefix = "tree";
  const meta = {
    ...(data?.meta ? data?.meta : {}),
    prefix,
  };

  const headerProps = { items, prefix };
  const bodyProps = { items: data?.rows, keys };
  const props = { headerProps, bodyProps, meta, isLoading };

  return (
    <Stack gap="10px" overflow="hidden">
      <HubTableTemplate id="TreesTable" {...props} />
    </Stack>
  );
};

export default TreesTable;
